import { adminCatalogMockData, adminCatalogItemMockData } from "../data";
import { AdminCatalogState } from "../types/index";
import {} from "../components/CatalogTable/"

export const initialState: AdminCatalogState = {
    catalogData: adminCatalogMockData,
    CatalogItems: adminCatalogItemMockData,
    loading: false,
    error: ""
};